import React, { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Chevron } from "../assets/icons/Chevron.svg";
import { ReactComponent as AddDoc } from "../assets/icons/AddDox.svg";
import { ReactComponent as Delete } from "../assets/icons/Delete.svg";
import { ReactComponent as Add } from "../assets/icons/add.svg";
import { ReactComponent as Close } from "../assets/icons/Close.svg";
import { ReactComponent as CalendarIcon } from "../assets/icons/Calendar.svg";
import { ReactComponent as Left } from "../assets/icons/BackArrow.svg";
import { ReactComponent as Right } from "../assets/icons/Right.svg";
import { Dialog, Listbox, Transition } from "@headlessui/react";
import { useAuth } from "../utils/auth";
import { sdkWrapperURL } from "../utils/api-url-list";
import TextInput from "../components/TextInput";
import Datepicker from "react-tailwindcss-datepicker";
import ViewRecord from "./ViewRecord";
import LoadingScreen from "../components/LoadingScreen";

const renderDropdown = (label, options, value, onChange, isbgwhite) => (
  <div className="mb-4">
    <div className="flex">
      <label
        className={`block text-[12px] font-medium ${
          isbgwhite ? "text-black" : "text-white"
        } mb-1`}
      >
        {label}
      </label>{" "}
      <span className="text-error">*</span>
    </div>
    <Listbox value={value} onChange={onChange}>
      <div className="relative">
        <Listbox.Button
          className={`w-full mt-2 px-4 py-2 rounded-lg outline-none border-2 focus:border-secondary bg-white text-primary text-xs`}
        >
          <span className="block truncate text-start">{value}</span>

          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <Chevron className="shrink-0 h-3.5 w-3.5 mt-1 text-secondary group-disabled:hidden" />
          </span>
        </Listbox.Button>
        <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white text-primary py-1 text-xxs shadow-lg ring-1 ring-primary ring-opacity-5 focus:outline-none">
          {options.map((option) => (
            <Listbox.Option
              key={option}
              className={({ active }) =>
                `relative cursor-pointer select-none py-2 pl-10 pr-4 ${
                  active ? "bg-secondary text-primary" : "text-primary bg-white"
                }`
              }
              value={option}
            >
              {({ selected }) => (
                <>
                  <span
                    className={`block truncate  ${
                      selected
                        ? " text-primary font-semibold"
                        : "font-normal text-primary"
                    }`}
                  >
                    {option}
                  </span>
                </>
              )}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </div>
    </Listbox>
  </div>
);

const MyDocument = () => {
  const {
    getToken,
    userData: { profile_id },
  } = useAuth();
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const [docType, setDocType] = useState("Documents");
  const [sortOrder, setSortOrder] = useState("Sort Descending");
  const [documents, setDocuments] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isDocModalOpen, setDocModalOpen] = useState(false);

  const [docName, setDocName] = useState("");
  const [instruction, setInstruction] = useState("");
  const [reportDate, setReportDate] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [modalDocType, setModalDocType] = useState("Documents");
  const [tags, setTags] = useState([{ key: "", value: "" }]);
  const [docNameError, setDocNameError] = useState("");
  const [instructionError, setInstructionError] = useState("");
  const [reportDateError, setReportDateError] = useState("");
  const [fileError, setFileError] = useState("");
  const [hasSaved, setSaved] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [isPreviewModalOpen, setPreviewModalOpen] = useState(false);
  const [uri, setUri] = useState("");

  const [docName2, setDocName2] = useState("");
  const [uploadedFile2, setUploadedFile2] = useState("");
  const [docNameError2, setDocNameError2] = useState("");
  const [fileError2, setFileError2] = useState("");
  const [docID, setDocId] = useState("");
  const [isDocModalOpen2, setDocModalOpen2] = useState(false);

  // add doc modal section

  const handleTagChange = (index, field, value) => {
    const newTags = [...tags];
    if (!newTags[index]) return;
    newTags[index][field] = value;
    setTags(newTags);
  };

  const addTag = () => {
    setTags([...tags, { key: "", value: "" }]);
  };

  const removeTag = (index) => {
    setTags(tags.filter((_, i) => i !== index));
  };

  const blobToBase64 = (blob) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise((resolve) => {
      reader.onloadend = () => {
        resolve(reader.result.split(",", 2)[1]);
      };
    });
  };

  const documentTypes = ["Documents", "Lab Reports", "Prescriptions"];
  const sortOptions = ["Sort Descending", "Sort Ascending"];

  const docTypeMap = {
    Documents: { type_of_document: "doc", list_type: "document" },
    "Lab Reports": { type_of_document: "lab", list_type: "lab" },
    Prescriptions: { type_of_document: "pres", list_type: "prescription" },
  };
  const resetForm = () => {
    setSelectedDoc(null);
    setDocName("");
    setInstruction("");
    setReportDate("");
    setModalDocType("Documents");
    setUploadedFile(null);
    setTags([{ key: "", value: "" }]);

    setDocNameError("");
    setInstructionError("");
    setReportDateError("");
    setFileError("");
    setIsSubmitting(false);
  };

  const saveDocuments = async () => {
    try {
      setDocNameError("");
      setReportDateError("");
      setInstructionError("");
      setFileError("");
      const trimDocName = docName.trim();
      let hasError = false;
      if (!trimDocName) {
        setDocNameError("Document name is required.");
        hasError = true;
      }
      if (!instruction) {
        setInstructionError("Instruction is required.");
        hasError = true;
      }
      if (!reportDate) {
        setReportDateError("Report date is required.");
        hasError = true;
      }
      if (!uploadedFile || uploadedFile.size > 5242880) {
        setFileError("Please upload your document. (<5MB)");
        hasError = true;
      } else {
        const extension = uploadedFile.name.split(".").pop().toLowerCase();
        const allowedExtensions = [
          "pdf",
          "doc",
          "docx",
          "xls",
          "xlsx",
          "jpg",
          "jpeg",
          "png",
          "webp",
        ];
        if (!allowedExtensions.includes(extension)) {
          setFileError("Unsupported file type.");
          hasError = true;
        } else {
          setFileError("");
        }
      }

      if (hasError) return;
      setIsSubmitting(true);
      const token = await getToken();
      const finalTags = [
        { key: "testname", value: docName },
        { key: "instructions", value: instruction },
        ...tags.filter((tag) => tag.key && tag.value),
      ];
      const uploadDocResp = await fetch(sdkWrapperURL("/users/docs/upload"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          pd_id: profile_id,
          file_name: `${docName}${
            /(?:\.([^.]+))?$/.exec(uploadedFile.name)?.[0]
          }`,
          report_date: reportDate,
          file: await blobToBase64(uploadedFile),
          tags: finalTags,
          doc_type: docTypeMap[modalDocType].list_type,
        }),
      });
      const uploadDocRespJSON = await uploadDocResp.json();
      if (uploadDocRespJSON?.statusCode?.toString().startsWith("2")) {
        setIsSaved(true);
        setTimeout(() => {
          setIsSaved(false);
          setDocModalOpen(false);
          resetForm();
        }, 2000);
        documentList();
      } else {
        throw Error(uploadDocRespJSON.data.message);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const documentList = async () => {
    setLoading(true);
    try {
      const token = await getToken();
      const payload = {
        pd_id: profile_id,
        table_config_rows_per_page: "15",
        table_config_page_no: page.toString(),
        doc_type: docTypeMap[docType].list_type,
        sort: sortOrder === "Sort Descending" ? "desc" : "asc",
        appointment_id: "",
      };

      const docResp = await fetch(sdkWrapperURL("/users/docs/list"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(payload),
      });
      const docRespJson = await docResp.json();
      if (docRespJson?.statusCode?.toString().startsWith("2")) {
        setDocuments(docRespJson.body);
        setTotalPages(Number(docRespJson.total_pages_count));
      } else {
        throw Error("Data not fetched");
      }
    } catch (error) {
      console.error("Failed to fetch documents:", error);
      setDocuments([]);
    } finally {
      setLoading(false);
    }
  };

  const getPresignedUrl = async (presigned_uri) => {
    const token = await getToken();
    const response = await fetch(sdkWrapperURL("/users/docs/view"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({ pd_id: profile_id, presigned_uri }),
    });

    const data = await response.json();
    return data.body;
  };

  useEffect(() => {
    documentList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [docType, sortOrder, page]);

  const closeDocModal = () => {
    resetForm();
    setDocModalOpen(false);
  };
  const closeDocModal2 = () => {
    setDocName2("");
    setUploadedFile2(null);
    setDocModalOpen2(false);
    setFileError2("");
  };

  const addDocumnet = async () => {
    setIsUpdating(true);
    try {
      setDocNameError2("");

      const trimDocName2 = docName2.trim();

      let hasError = false;
      if (!trimDocName2) {
        setDocNameError2("Document name is required.");
        hasError = true;
      }
      if (!uploadedFile2 || uploadedFile2.size > 5242880) {
        setFileError2("Please upload your document. (<5MB)");
        hasError = true;
      } else {
        const extension = uploadedFile2.name.split(".").pop().toLowerCase();
        const allowedExtensions = [
          "pdf",
          "doc",
          "docx",
          "xls",
          "xlsx",
          "jpg",
          "jpeg",
          "png",
          "webp",
        ];
        if (!allowedExtensions.includes(extension)) {
          setFileError2("Unsupported file type.");
          hasError = true;
        } else {
          setFileError2("");
        }
      }

      if (hasError) return;
      const token = await getToken();
      const uploadDocResp = await fetch(sdkWrapperURL("/users/docs/update"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          pd_id: profile_id,
          file_name: `${docName2}${
            /(?:\.([^.]+))?$/.exec(uploadedFile2.name)?.[0]
          }`,
          file: await blobToBase64(uploadedFile2),
          docs_id: docID ? docID : "",
        }),
      });
      const uploadDocRespJSON = await uploadDocResp.json();
      if (uploadDocRespJSON?.statusCode?.toString().startsWith("2")) {
        setSaved(true);
        setTimeout(() => {
          setSaved(false);
          setDocModalOpen2(false);
        }, 1000);
        documentList();
      } else {
        throw Error(uploadDocRespJSON.data.message);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsUpdating(false);
      setUploadedFile2(null);
    }
  };

  const getTagValue = (tags, key) =>
    tags.find((tag) => tag.key.toLowerCase() === key.toLowerCase())?.value ||
    "-";

  return loading ? (
    <LoadingScreen style={{ minHeight: "60vh" }} />
  ) : (
    <section className="min-h-screen px-6 pb-24 relative bg-primary text-white">
      <div className="flex justify-between">
        <div className="flex items-center mb-5">
          <Link to={-1} className="mr-3">
            <svg
              width="6"
              height="10"
              viewBox="0 0 10 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.42402 16.2142C9.99277 15.6454 9.99277 14.7267 9.42402 14.1579L3.76569 8.49959L9.42402 2.84126C9.99277 2.27251 9.99277 1.35376 9.42402 0.785009C8.85527 0.216259 7.93652 0.216259 7.36777 0.785009L0.674024 7.47876C0.105274 8.04751 0.105274 8.96626 0.674024 9.53501L7.36777 16.2288C7.92194 16.7829 8.85527 16.7829 9.42402 16.2142Z"
                fill="#fff"
              />
            </svg>
          </Link>
          <h3 className="text-white text-[14px] font-semibold">My Documents</h3>
        </div>
        <div className="flex justify-between">
          <AddDoc className="shrink-0 h-5 w-5 mr-2 text-secondary group-disabled:hidden" />
          <span
            className="text-white text-xs font-semibold cursor-pointer"
            onClick={() => setDocModalOpen(true)}
          >
            Add Documents
          </span>
        </div>
      </div>

      <div className="flex justify-between gap-2 mb-4">
        <div className="w-[47%]">
          {renderDropdown("Document Type", documentTypes, docType, setDocType)}
        </div>
        <div className="w-[47%]">
          {renderDropdown("Sort Order", sortOptions, sortOrder, setSortOrder)}
        </div>
      </div>

      <div className="space-y-4 mt-4">
        {documents.length === 0 ? (
          <p className="text-gray-500 text-sm">No documents found.</p>
        ) : (
          <div className="grid grid-cols-1 gap-4">
            {documents.map((doc) => (
              <div
                key={doc.docs_id}
                className="bg-white border rounded-xl p-3 shadow hover:shadow-md transition"
              >
                <div>
                  <div className="flex-1">
                    <h2 className="text-lg font-semibold text-primary">
                      {`${doc?.file_name}`.split(".")[0] ||
                        getTagValue(doc.tags, "testname")}
                    </h2>
                    <div className="flex justify-between">
                      <p className="text-sm text-gray-600">
                        Uploaded by:{" "}
                        <span className="font-medium text-gray-700">
                          {doc.uploaded_by}
                        </span>
                      </p>
                      <p className="text-sm text-gray-600">
                        Date:{" "}
                        <span className="font-medium text-gray-700">
                          {new Date(doc.report_date).toLocaleDateString()}
                        </span>
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-sm text-gray-600">
                        Instruction:{" "}
                        <span className="font-medium text-gray-700">
                          {getTagValue(doc.tags, "instructions")}
                        </span>
                      </p>
                      <p className="text-sm text-gray-600">
                        status:{" "}
                        <span className="font-medium text-gray-700">
                          {doc.status}
                        </span>
                      </p>
                    </div>
                  </div>

                  {/* Right: Actions */}
                  <div className="flex-shrink-0 flex flex-col gap-2 md:items-end">
                    {doc.status === "requested" ? (
                      <div className="flex justify-end">
                        <button
                          className="mt-3 w-20 space-x-2 rounded-2xl outline-none px-3 py-2 bg-gradient disabled:bg-secondary text-white"
                          onClick={() => {
                            setDocId(doc.docs_id);
                            setDocName2(
                              doc.file_name.split(".")[0] ||
                                getTagValue(doc.tags, "testname")
                            );
                            setDocModalOpen2(true);
                          }}
                        >
                          Add
                        </button>
                      </div>
                    ) : (
                      <div className="flex justify-end space-x-2 mt-3">
                        <button
                          className="w-24 rounded-full px-4 py-2 bg-gradient text-white hover:opacity-90 disabled:bg-gray-400"
                          onClick={() => {
                            setSelectedDoc(doc);
                            setDocId(doc.docs_id);
                            setDocName2(
                              doc.file_name.split(".")[0] ||
                                getTagValue(doc.tags, "testname")
                            );
                            setDocModalOpen2(true);
                          }}
                        >
                          Update
                        </button>
                        <button
                          onClick={async () => {
                            const finalURL = await getPresignedUrl(
                              doc.presigned_uri
                            );
                            setUri(finalURL);
                            setPreviewModalOpen(true);
                          }}
                          className="w-24 rounded-full px-4 py-2 bg-black text-white hover:opacity-90 disabled:bg-gray-400"
                        >
                          View
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        <div className="flex justify-center items-center gap-4 mt-4">
          <button disabled={page === 1} onClick={() => setPage(page - 1)}>
            <Left className="h-5 w-5 text-secondary" />
          </button>
          <span className="text-sm text-gray-700">
            Page {page} of {totalPages}
          </span>
          <button
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
          >
            <Right className="h-8 w-8 text-secondary" />
          </button>
        </div>
      </div>

      {/* Add Documents Modal */}
      <Transition show={isDocModalOpen} as={Fragment}>
        <Dialog
          open={isDocModalOpen}
          onClose={closeDocModal}
          className="relative z-50"
          as={Fragment}
        >
          <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
            <Transition.Child
              className="fixed inset-0 bg-black/70 flex items-center justify-center"
              enter="duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="duration-300 delay-150"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Transition.Child
                as={Fragment}
                enter="delay-150 duration-200"
                enterFrom="opacity-0 scale-50"
                enterTo="opacity-100 scale-100"
                leave="duration-100"
                leaveFrom="opacity-50 scale-50"
                leaveTo="opacity-0 scale-0"
              >
                <Dialog.Panel className="w-11/12 max-h-[90vh] overflow-y-auto bg-white rounded-xl p-5 flex flex-col relative">
                  <div onClick={closeDocModal}>
                    <Close className="h-5 w-5 text-primary absolute top-3 right-3" />
                  </div>
                  <Dialog.Title className="text-left font-semibold">
                    {selectedDoc ? "Update Document" : "Add Document"}
                  </Dialog.Title>
                  <form className="space-y-6">
                    <TextInput
                      type="text"
                      id="Name"
                      label="Name"
                      placeholder="Please Mention Document Name"
                      autoComplete="given-name"
                      required
                      onChangeText={setDocName}
                      value={docName}
                      error={docNameError}
                    />

                    <TextInput
                      type="text"
                      id="Instruction"
                      label="Instruction"
                      placeholder="Instruction"
                      autoComplete="given-name"
                      required
                      onChangeText={setInstruction}
                      value={instruction}
                      error={instructionError}
                    />

                    {/* Report Date */}
                    <div>
                      <label htmlFor="report-date" className="text-xs">
                        Report Date <span className="text-error">*</span>
                      </label>
                      <Datepicker
                        inputId="report-date"
                        primaryColor="blue"
                        containerClassName={`relative mt-2 px-4 py-2 flex items-center justify-between space-x-2.5 rounded-lg border-2${
                          reportDateError?.length > 0 ? " border-error" : ""
                        } focus:border-secondary bg-white text-primary`}
                        inputClassName="grow text-xs bg-transparent outline-none"
                        toggleClassName="shrink-0 h-4 w-4 pointer-events-none"
                        toggleIcon={() => (
                          <CalendarIcon className="h-full w-full" />
                        )}
                        value={
                          reportDate
                            ? { startDate: reportDate, endDate: reportDate }
                            : null
                        }
                        onChange={(date) => setReportDate(date.startDate)}
                        useRange={false}
                        asSingle
                        readOnly
                        placeholder="Select report date"
                        displayFormat="DD/MM/YYYY"
                        maxDate={new Date()}
                      />
                      {reportDateError?.length > 0 && (
                        <p className="mt-1.5 text-xxs text-error">
                          {reportDateError}
                        </p>
                      )}
                    </div>

                    <div className="w-[100%]">
                      {renderDropdown(
                        "Document Type",
                        documentTypes,
                        modalDocType,
                        setModalDocType,
                        true
                      )}
                    </div>

                    {/* Upload Document */}
                    <div className="mb-4">
                      <label
                        htmlFor="file-upload"
                        className="block text-xs mb-1"
                      >
                        Upload Document <span className="text-error">*</span>
                      </label>
                      <input
                        id="file-upload"
                        type="file"
                        accept=".jpg,.jpeg,.webp,.png,.pdf,.doc,.docx,.xls,.xlsx"
                        onChange={(e) => setUploadedFile(e.target.files[0])}
                        className="block w-full px-4 py-2 rounded-lg border-2 border-gray-300 focus:border-secondary bg-white text-primary text-xs"
                      />
                      {fileError.length > 0 && (
                        <p className="mt-1.5 text-xxs text-error">
                          {fileError}
                        </p>
                      )}

                      {uploadedFile && (
                        <div className="flex items-center space-x-2">
                          {uploadedFile.type.startsWith("image/") ? (
                            <img
                              src={URL.createObjectURL(uploadedFile)}
                              alt={uploadedFile.name}
                              className="w-12 h-12 object-cover rounded"
                            />
                          ) : (
                            <span className="text-xs">{uploadedFile.name}</span>
                          )}
                          <button
                            type="button"
                            onClick={() => {
                              setUploadedFile(null);
                              setFileError("Please select a document.");
                            }}
                            className="text-secondary text-xs"
                          >
                            <Delete className="shrink-0 h-5 w-5 mr-2 text-secondary group-disabled:hidden" />
                          </button>
                        </div>
                      )}
                    </div>

                    {/* Tags */}
                    <div className="mb-4">
                      <label className="block text-xs mb-1">Tags</label>
                      <div className="space-y-2">
                        {tags.map((tag, index) => (
                          <div key={index} className="flex space-x-2">
                            <TextInput
                              type="text"
                              id="Key"
                              placeholder="Key"
                              autoComplete="given-name"
                              onChangeText={(value) =>
                                handleTagChange(index, "key", value)
                              }
                              value={tag.key}
                            />
                            <TextInput
                              type="text"
                              id="Value"
                              placeholder="Value"
                              autoComplete="given-name"
                              onChangeText={(value) =>
                                handleTagChange(index, "value", value)
                              }
                              value={tag.value}
                            />
                            {tags.length > 1 && (
                              <button
                                type="button"
                                onClick={() => removeTag(index)}
                                className="text-secondary text-xs"
                              >
                                <Delete className="shrink-0 h-5 w-5 mr-2 text-secondary group-disabled:hidden" />
                              </button>
                            )}
                          </div>
                        ))}
                      </div>
                      <button
                        type="button"
                        onClick={addTag}
                        className="mt-2 text-xs float-right"
                      >
                        <Add className="shrink-0 h-4 w-4 mr-2 text-secondary group-disabled:hidden" />
                      </button>
                    </div>
                    {isSaved && (
                      <p className="mt-2 text-center text-sm font-normal text-light-green-500">
                        ✅ file Updated Successfully
                      </p>
                    )}

                    <div>
                      <button
                        className={`mt-6 mx-auto w-40 space-x-2.5 rounded-full outline-none px-5 py-2.5 text-white float-end ${
                          isSubmitting ? "bg-lightgray" : "bg-gradient"
                        }`}
                        type="button"
                        onClick={saveDocuments}
                        disabled={isSubmitting}
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </Dialog.Panel>
              </Transition.Child>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
      {/* Action-Add document */}

      <Transition show={isDocModalOpen2} as={Fragment}>
        <Dialog
          open={isDocModalOpen2}
          onClose={closeDocModal2}
          className="relative z-50"
          as={Fragment}
        >
          <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
            <Transition.Child
              className="fixed inset-0 bg-black/70 flex items-center justify-center"
              enter="duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="duration-300 delay-150"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Transition.Child
                as={Fragment}
                enter="delay-150 duration-200"
                enterFrom="opacity-0 scale-50"
                enterTo="opacity-100 scale-100"
                leave="duration-100"
                leaveFrom="opacity-50 scale-50"
                leaveTo="opacity-0 scale-0"
              >
                <Dialog.Panel className="w-11/12 bg-white rounded-xl p-5 flex flex-col relative">
                  <div onClick={closeDocModal2}>
                    <Close className="h-5 w-5 text-primary absolute top-3 right-3" />
                  </div>
                  <Dialog.Title className="text-left font-semibold">
                    {selectedDoc ? "Update Documents" : " Add Documents"}
                  </Dialog.Title>
                  <form className="space-y-6">
                    <TextInput
                      type="text"
                      id="Name"
                      label="Name"
                      placeholder="Please Mention Document Name"
                      autoComplete="given-name"
                      required
                      onChangeText={setDocName2}
                      value={docName2}
                      error={docNameError2}
                    />

                    {/* Upload Document */}
                    <div className="mb-4">
                      <label
                        htmlFor="file-upload"
                        className="block text-xs mb-1"
                      >
                        Upload Document <span className="text-error">*</span>
                      </label>
                      <input
                        id="file-upload"
                        type="file"
                        accept=".jpg,.jpeg,.webp,.png,.pdf,.doc,.docx,.xls,.xlsx"
                        multiple
                        onChange={(e) => setUploadedFile2(e.target.files[0])}
                        className="block w-full px-4 py-2 rounded-lg border-2 border-gray-300 focus:border-secondary bg-white text-primary text-xs"
                      />
                      {fileError2.length > 0 && (
                        <p className="mt-1.5 text-xxs text-error">
                          {fileError2}
                        </p>
                      )}

                      {uploadedFile2 && (
                        <div className="flex items-center space-x-2">
                          {uploadedFile2.type.startsWith("image/") ? (
                            <img
                              src={URL.createObjectURL(uploadedFile2)}
                              alt={uploadedFile2.name}
                              className="w-12 h-12 object-cover rounded"
                            />
                          ) : (
                            <span className="text-xs">
                              {uploadedFile2.name}
                            </span>
                          )}
                          <button
                            type="button"
                            onClick={() => {
                              setUploadedFile2(null);
                              setFileError2("Please select a document.");
                            }}
                            className="text-secondary text-xs"
                          >
                            <Delete className="shrink-0 h-5 w-5 mr-2 text-secondary group-disabled:hidden" />
                          </button>
                        </div>
                      )}
                    </div>

                    {/* Tags */}
                    {hasSaved && (
                      <p className="mt-2 text-center text-sm font-normal text-light-green-500">
                        ✅ file Updated Successfully
                      </p>
                    )}

                    <div>
                      <button
                        className={`mt-6 mx-auto w-40 space-x-2.5 rounded-full outline-none px-5 py-2.5 text-white float-end ${
                          isUpdating ? "bg-lightgray" : "bg-gradient"
                        }`}
                        type="button"
                        onClick={addDocumnet}
                        disabled={isUpdating}
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </Dialog.Panel>
              </Transition.Child>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>

      {/* view Modal */}
      {isPreviewModalOpen && (
        <ViewRecord
          isOpen={isPreviewModalOpen}
          onClose={() => setPreviewModalOpen(false)}
          record={uri}
        />
      )}
    </section>
  );
};

export default MyDocument;
